function Page_background_form_edit(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    fieldColor: '.js-field-color',
	    colorBox: '.js-color-box'
    };

    this.triggers = {
	    afterLoaded: 'i4:afterLoaded'
    };

    this.init = function() {

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$fieldColor = this.$element.find(this.selectors.fieldColor);
	    this.$colorBox = this.$element.find(this.selectors.colorBox);

		this.$fieldColor.on('i4:change', this.$onChangeColor.bind(this));

		this.$formParent.on(this.triggers.afterLoaded, (function() {
			this.$onChangeColor();
		}).bind(this));
    };

    this.$onChangeColor = function() {
	    this.$colorBox.css('backgroundColor', this.$fieldColor.val());
    };
}
